module.exports = __webpack_public_path__ + "img/bradesco.285bc471.svg";